import { Mail, Phone, MapPin, Clock, MessageCircle, Instagram, Facebook, Youtube } from "lucide-react";
import { PageHeader } from "./ServiceDetail";
import { GoldButton, Reveal } from "../components/ui-kit";
import { useContent } from "../context/ContentContext";

export default function Contact() {
  const { content } = useContent();
  const c = content?.contact || {};
  const rows = [
    { Icon: Mail, label: "E-mail", value: c.email || "contact@kmrevent.com", href: `mailto:${c.email || "contact@kmrevent.com"}` },
    { Icon: Phone, label: "Téléphone", value: c.phone || "À compléter", href: c.phone ? `tel:${c.phone}` : null },
    { Icon: Clock, label: "Disponibilité", value: c.hours || "À compléter" },
    { Icon: MapPin, label: "Zone d'intervention", value: c.zone || "À préciser" },
  ];
  const socials = [
    { key: "instagram", Icon: Instagram }, { key: "facebook", Icon: Facebook }, { key: "youtube", Icon: Youtube },
  ];
  return (
    <div data-testid="contact-page">
      <PageHeader overline="Contact" title="Parlons de votre événement" subtitle="Un projet, une question ou une demande de disponibilité ? Écrivez-nous, nous vous répondons rapidement." />
      <section className="pb-24">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-8">
          <Reveal>
            <div className="glass rounded-2xl p-8 space-y-5">
              {rows.map(({ Icon, label, value, href }) => (
                <div key={label} className="flex items-start gap-4">
                  <div className="glass p-3 rounded-full text-gold"><Icon size={20} /></div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-muted-foreground">{label}</p>
                    {href ? <a href={href} className="text-foreground hover:text-gold transition-colors">{value}</a> : <p className="text-foreground">{value}</p>}
                  </div>
                </div>
              ))}
              {c.whatsappEnabled && c.whatsapp && (
                <a href={c.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:underline" data-testid="whatsapp-link">
                  <MessageCircle size={20} /> WhatsApp
                </a>
              )}
              <div className="flex gap-3 pt-3">
                {socials.map(({ key, Icon }) => c[key] ? (
                  <a key={key} href={c[key]} target="_blank" rel="noopener noreferrer" className="glass p-2.5 rounded-full hover:text-gold transition-colors" aria-label={key}><Icon size={18} /></a>
                ) : null)}
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="glass rounded-2xl p-8 flex flex-col justify-center h-full text-center">
              <h3 className="font-serif text-2xl">Prêt à démarrer ?</h3>
              <p className="text-muted-foreground mt-3 mb-6">Le moyen le plus rapide d'obtenir une proposition est notre formulaire de devis détaillé.</p>
              <GoldButton to="/devis" data-testid="contact-devis-btn">Demander un devis</GoldButton>
              <GoldButton to="/devis?type=autre" variant="outline" className="mt-3" data-testid="contact-rappel-btn">Être rappelé</GoldButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
